import React from 'react';

export default function BlogSidebarAds() {
  return (
    <div className="space-y-8 sticky top-24">
      <div className="bg-[#15151e] border border-white/5 rounded-xl p-6 text-center text-white/40">
        <div className="aspect-square bg-white/5 rounded-lg flex items-center justify-center mb-4">
          <span className="text-xs uppercase tracking-widest font-semibold text-white/20">Ad Slot 1</span>
        </div>
        <p className="text-xs">Advertisement</p>
      </div>

      <div className="bg-gradient-to-br from-fuchsia-900/10 to-purple-900/10 border border-fuchsia-500/20 rounded-xl p-6 text-center">
        <h4 className="text-white font-bold mb-2">Try AI Hairstyle Studio</h4>
        <p className="text-sm text-white/60 mb-4">Transform your look instantly with our advanced AI technology.</p>
        <a href="/app" className="inline-block w-full px-4 py-3 bg-fuchsia-600 hover:bg-fuchsia-500 text-white text-sm font-bold rounded-xl transition-colors shadow-lg shadow-fuchsia-900/20">
          Try Now
        </a>
      </div>
    </div>
  );
}
